import { atom } from 'jotai';

export const objectTitleAtom = atom<string | null>(null);

export const chatThreadTitleAtom = atom<string | null>(null);

export const documentTitlePrefixAtom = atom<string>('');
